import {
  type OpenedPositionsPayload,
  type PendingOrdersPayload,
  type PositionsHistoryPayload,
  type TickPayload,
  type TradingOperationDragResolvedPayload,
  type UiElementsConfigPayload,
} from '#/types/messages';

export enum MessageListenerHandlerKey {
  Tick = 'tick',
  BidAndAsk = 'bidAndAsk',

  HmrShowing = 'hmrShowing',
  OpenedPositionsShowing = 'openedPositionsShowing',
  PendingOrdersShowing = 'pendingOrdersShowing',
  SlTpShowing = 'slTpShowing',

  OpenedPositions = 'openedPositions',
  PendingOrders = 'pendingOrders',
  TradingOperationDragResolved = 'tradingOperationDragResolved',

  PositionsHistoryShowing = 'positionsHistoryShowing',
  PositionsHistory = 'positionsHistory',
}

export type MessagesChannel =
  | TickPayload['type']
  | UiElementsConfigPayload['type']
  | OpenedPositionsPayload['type']
  | PendingOrdersPayload['type']
  | TradingOperationDragResolvedPayload['type']
  | PositionsHistoryPayload['type'];

export interface IMessageListenerService {
  setHandler: (
    channel: MessagesChannel,
    handlerKey: MessageListenerHandlerKey,
    handler: (messagePayload: unknown) => void
  ) => void;
}
